import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';

import Form, { FormProps } from 'components/Form/Form';

import './_modalForm.scss';

type Props = Partial<FormProps> & {
    closeModal: () => void;
    fullWidth?: boolean;
    isClickOutsideEnabled?: boolean;
    secondary?: React.ReactNode;
    show: boolean;
    title: string;
};

function ModalForm({
    className,
    show,
    isClickOutsideEnabled = true,
    closeModal,
    fullWidth = true,
    secondary = null,
    title,
    ...otherProps
}: Props) {
    const { t } = useTranslation();
    return (
        <Dialog
            open={show}
            onClick={
                !isClickOutsideEnabled
                    ? (event) => event.stopPropagation()
                    : undefined
            }
            onClose={closeModal}
            className={`modal-form ${className ? className : ''}`}
            fullWidth={fullWidth}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContentText className="form-body">
                {secondary}
            </DialogContentText>
            <DialogContent style={{ padding: 0 }}>
                <Form
                    {...otherProps}
                    leftButton={
                        <Button
                            onClick={closeModal}
                            className="e2e-modal-close-button"
                        >
                            {t('common.cancel')}
                        </Button>
                    }
                />
            </DialogContent>
        </Dialog>
    );
}

export default ModalForm;
